<template>
    <v-row v-if="value">
        <v-col>
            <v-card disabled>
                <v-card-title class="subtitle-2 font-weight-bold">
                    상세정보1
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0 caption">
                                    <span>시공분야</span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="py-0 caption">
                                    <v-radio-group v-model="value.meta.interiorType" row hide-details class="mt-0">
                                        <v-radio v-for="(field, index) in field_item" :key="index" :label="field" :value="field"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4" v-if="value.meta.interiorCategories">
                        <v-col cols="12" class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0 caption">
                                    <span>부분인테리어 카테고리</span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-chip v-for="(area, index) in value.meta.interiorCategories" :key="index" :value="area" class="mr-2 mt-2">
                                        {{ area }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4" v-if="value.meta.interiorAreas">
                        <v-col cols="12" class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0 caption">
                                    <span>시공지역</span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="py-0 caption">
                                    <v-chip v-for="(area, index) in value.meta.interiorAreas" :key="index" :value="area" class="mr-2 mt-2">
                                        {{ area }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
export default {
    components: { NaverSmarteditor },
    props: {
        value: Object,
    },
    data() {
        return {
            field_item: ["종합인테리어", "부분인테리어"],
        };
    },
    computed: {
        interiorCareer() {
            return [this.value.meta.interiorCareerYear, this.value.meta.interiorCareerMonth].reduce((s, t, i) => (t ? s + (i ? ` ${t}월` : `${t}년`) : s), "");
        },
    },
};
</script>

<style></style>
